import ProfileHeader from 'components/profile-header';
import ProfileSettings from 'components/profile-settings';
import { SettingsListType } from 'components/profile-settings/types';
import ChangeEmailModal from 'modals/change-email-modal';
import ChangeNameModal from 'modals/change-name-modal';
import ResetPasswordModal from 'modals/reset-password-modal';
import { UserProfileType } from 'models/user.model';
import React, { useEffect, useState } from 'react';
import { apiService } from 'services/base.service';
import { getUserFullName, handleApiError, updateLocalStorageUserData } from 'utils/functions';

const Profile = () => {
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showChangeEmailModal, setShowChangeEmailModal] = useState(false);
  const [showChangeNameModal, setShowChangeNameModal] = useState(false);
  const [user, setUser] = useState<UserProfileType>();

  const getUser = async () => {
    try {
      const res = await apiService.get('user/me');
      updateLocalStorageUserData(res.data.data);
      setUser(res.data.data);
    } catch {
      handleApiError('Error getting users');
    }
  };
  useEffect(() => {
    getUser();
  }, []);

  const getAccessLevel = (role: UserProfileType['role'] | undefined) => {
    if (!role) return '';
    return role.name ?? '';
  };

  const accessLevel = getAccessLevel(user?.role);

  const PROFILE_LIST: SettingsListType[] = [
    {
      label: 'Name',
      value: getUserFullName(user),
      buttonText: 'Edit',
      onClick: () => {
        setShowChangeNameModal(true);
      }
    },

    {
      label: 'Access level',
      value: accessLevel,
      onClick: () => {
        console.log('r');
      },
      buttonText: 'Edit',
      buttonClass: 'hidden'
    },

    {
      label: 'Email',
      value: user?.email ?? '',
      onClick: () => {
        setShowChangeEmailModal(true);
      },
      description: !user?.email_confirmed ? 'Not confirmed' : ''
    },

    {
      label: 'Password',
      value: `*********************`,
      onClick: () => {
        setShowResetPasswordModal(true);
      },
      buttonText: 'Reset'
    }
  ];

  return (
    <div>
      <ProfileHeader />
      <div className='border-[#F2F2F3] border rounded-[8px] w-[637px] px-6 mt-[34px]'>
        <ProfileSettings list={PROFILE_LIST} />
      </div>
      {showResetPasswordModal && (
        <ResetPasswordModal
          show={showResetPasswordModal}
          onClose={() => setShowResetPasswordModal(false)}
        />
      )}
      {showChangeEmailModal && (
        <ChangeEmailModal
          show={showChangeEmailModal}
          onClose={() => setShowChangeEmailModal(false)}
          refreshUser={getUser}
          user={user}
        />
      )}
      {showChangeNameModal && (
        <ChangeNameModal
          user={user}
          show={showChangeNameModal}
          onClose={() => setShowChangeNameModal(false)}
          refreshUser={getUser}
        />
      )}
    </div>
  );
};

export default Profile;
